<template>
  <div class="map-wrapper">
    <div id="map"></div>
  </div>
</template>

<script>
import {GoogleMapsService} from "@/services/google-maps-service";

export default {
  name: 'Map',
  props: {
    lat: Number,
    lng: Number,
  },
  updated() {
    const navbarService = new GoogleMapsService();
    const markerImage = require("../assets/marker.png");
    document.getElementById('map').innerHTML = '';
    navbarService.changeMap('map', this.lat, this.lng, markerImage);
  }
}

</script>

<style lang="scss">
  #map {
    height: 400px;
    margin-top: 30px;
  }
</style>